import axios from "axios";
//GET ALL CARCATAGORY BY COUNTRY
export const GET_CUSTOMER_CASE_DETAIL = "GET_CUSTOMER_CASE_DETAIL";
export const GET_CUSTOMER_CASE_DETAIL_LOADING =
"GET_CUSTOMER_CASE_DETAIL_LOADING";
export const GET_CUSTOMER_CASE_DETAIL_LOADING_FAILED =
"GET_CUSTOMER_CASE_DETAIL_LOADING_FAILED";

// HELPER ACTIONS CREATORS
//************************************** /

export const getCaseDetailLoading = ms => ({
    type: GET_CUSTOMER_CASE_DETAIL_LOADING,
    payload: ms
    });
    
    export const getCaseDetailLoadingFailed = ms => ({
    type: GET_CUSTOMER_CASE_DETAIL_LOADING_FAILED,
    payload: ms
    });

// RIDER PHINE NUBER
export function getCaseDetail(id) {
        const request = axios.get(
            `https://prod-legalemirates.wowets.com/fileService/receptionistRoutes/api/v1/cases/getCaseById/${id}`, {
                headers: { 'Authorization': 'bearer ' +localStorage.receptionistToken}
              });
   
    
    return dispatch => {

    dispatch(getCaseDetailLoading());
    request
    .then(response => {   
  
    if (response.status == 200 || response.status == 201) {
     console.log(response,"response getCaseDetail")
    dispatch({
    type: GET_CUSTOMER_CASE_DETAIL,
    payload: response.data
    });
  
    } else {
      
    throw new Error(JSON.stringify(response.data.response.msg));
    }
    })
    .catch(error => {
        
    if (error.response) {
    if (error.response.status == "404") {
        console.log(error.response)
    dispatch(
        getCaseDetailLoadingFailed(error.response.data.message)
    );
    } else {
    dispatch(getCaseDetailLoadingFailed(error.response.data.message));
    }
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    dispatch(getCaseDetailLoadingFailed(error.request));
    
    console.log(error.request);
    } else {
    // Something happened in setting up the request and triggered an Error
    console.log("Error", error.message);
    dispatch(getCaseDetailLoadingFailed(error.message));
    }
    console.log(error);
    });
    };
    }


